(() => {
    const accordize = function (target, one) {
        // (A) GET TARGET CONTAINER
        target = document.getElementById(target);
        target.classList.add('awrap');

        // (B) ATTACH CLICK TO OPEN DRAWER
        if (typeof one != 'boolean') {
            one = false;
        }
        let head = target.getElementsByClassName('ahead');

        // (B1) ONLY ONE DRAWER CAN OPEN AT A TIME
        if (one) {
            for (let h of head) {
                h.addEventListener('click', function () {
                    for (let e of head) {
                        if (e != this) {
                            e.classList.remove('open');
                        } else {
                            this.classList.toggle('open');
                        }
                    }
                });
            }
        }

        // (B2) ALL DRAWERS CAN OPEN/CLOSE
        else {
            for (let h of head) {
                h.addEventListener('click', function () {
                    this.classList.toggle('open');
                });
            }
        }
    };

    const openInitialHashElement = function () {
        const hash = window.location.hash;
        if (!hash) {
            return;
        }
        const openElement = document.querySelector(hash);
        if (openElement) {
            const addClassElement = openElement.querySelector('.ahead');
            if (addClassElement) {
                addClassElement.classList.add('open');
            }
        }
    };

    const initAccordeon = () => {
        const accordionElements = document.querySelectorAll('.diu-neos-content-faq-item');
        accordionElements.forEach((accordion) => {
            accordize(accordion.id, false);
        });

        openInitialHashElement();
    };

    document.addEventListener('readystatechange', () => {
        if (document.readyState !== 'complete') return;
        initAccordeon();
    });
})();
